<template>
  <div class="order-detail">
    <div class="header-box" :class="['UNPAID'].includes(orderDetail.orderStatus) ? 'header-pending' : ''">
        <app-header @on-click="e_goBack"
            opacity
            backgroundColor="transparent"
            :title="$t('order.orderList.order_details')"></app-header>
            <div class="status-box">
                <template v-if="'FINISHED' === orderDetail.orderStatus">
                    <van-icon name="passed" /> {{$t('order.orderList.status_success')}}
                </template>
                <template v-if="'UNPAID' === orderDetail.orderStatus">
                    <van-icon name="clock-o" /> {{$t('order.orderList.status_pending')}}
                </template>
                <template v-if="['CLOSE'].includes(orderDetail.orderStatus)">
                    <van-icon name="warning-o" /> {{$t('order.orderList.status_cancel')}}
                </template>
                <template v-if="['CANCEL'].includes(orderDetail.orderStatus)">
                    <van-icon name="clock-o" /> {{$t('order.orderList.status_unsub')}}
                </template>
            </div>
    </div>
    <div class="package-detail">
        <h2>{{orderDetail.packageObj ? orderDetail.packageObj.goodsName : ''}}</h2>
        <p class="amont-title"><span class="goodsPrice">{{orderDetail.goodsPriceText}}</span> x {{orderDetail.packageObj.quantity}}</p>
        <van-cell class="mt16" :title="$t('packages.detail.cell_flow')" :value="orderDetail.showFlow" :border="false"></van-cell>
        <van-cell :title="$t('packages.detail.cell_period')" :value="orderDetail.showPeriod" :border="false"></van-cell>
    </div>

    <div class="order-amont ml10 mr10 border-bottom">
        <van-cell :title="$t('order.orderList.total_amont')" :value="orderDetail.originalAmountText" :border="false"></van-cell>
        <van-cell v-if="orderDetail.discountAmount" :value-class="isCurrencySymbol(orderDetail.currencyType) ? '' : 'arValue'" :title="orderDetail.promotionName || orderDetail.actName" :value="'- ' + orderDetail.discountAmountText" :border="false"></van-cell>
        <van-cell :title="$t('order.orderList.amount_paid')" value-class="pay-amont" :value="orderDetail.amountText" :border="false"></van-cell>
    </div>

    <div class="order-info ml10 mr10 border-bottom">
        <van-cell :title="$t('order.orderList.orderSN')" value-class="flex2" :value="orderDetail.orderSN" :border="false"></van-cell>
        <van-cell :title="$t('order.orderList.createTime')" :value="orderDetail.createTime | filterTime" :border="false"></van-cell>
        <van-cell v-if="orderDetail.cancelTime && !['FINISHED','CANCEL'].includes(orderDetail.orderStatus)" :title="$t('order.orderList.cancelTime')" :value="orderDetail.cancelTime | filterTime" :border="false"></van-cell>
        <van-cell v-if="orderDetail.payTime" :title="$t('order.orderList.payTime')" :value="orderDetail.payTime | filterTime" :border="false"></van-cell>
        <van-cell v-if="orderDetail.refundTime && !['UNPAID','CLOSE'].includes(orderDetail.orderStatus)" :title="$t('order.orderList.unsubTime')" :value="orderDetail.refundTime | filterTime" :border="false"></van-cell>
        <van-cell v-if="orderDetail.payMethod && !['UNPAID','CLOSE'].includes(orderDetail.orderStatus)" :title="$t('order.orderList.payMethod')" :value="getLabel(orderDetail.payMethod)" :border="false"></van-cell>
        <van-cell v-if="orderDetail.thirdSn" :title="$t('order.orderList.thirdSN')" :value="orderDetail.thirdSn" :border="false"></van-cell>
    </div>

    <div class="device-info ml10 mr10 mt16">
        <van-cell :title="$t('order.orderList.device')" :value="orderDetail.groupVO.displayType" :border="false"></van-cell>
    </div>
    
    <div class="order-detail-footer">
        <!-- <van-button class="btn delete" round block type="info" @click.stop="goBuy">{{ $t('order.orderList.delete') }}</van-button> -->
        <van-button v-if="orderDetail.orderStatus === 'UNPAID'" class="btn delete" round block type="info" @click.stop="gotoCancel">{{ $t('registerlogin.cancel') }}</van-button>
        <!-- <van-button class="btn delete" round block type="info" @click.stop="goBuy">{{ $t('order.orderList.unsub') }}</van-button> -->
        <van-button v-if="orderDetail.orderStatus === 'UNPAID'" class="btn gobuy" round block type="info" @click.stop="gotoPay">{{ $t('packages.detail.pay') }}</van-button>
        <van-button v-if="['FINISHED','CANCEL','CLOSE'].includes(orderDetail.orderStatus) && isBuyFlag" class="btn gobuy" round block type="info" @click.stop="goBuy">{{ $t('digital.goBuy') }}</van-button>
    </div>
  </div>
</template>

<script>
import cookie from '@/utils/cookie';
import dateUtil from "@/utils/DateUtil";
import { keepTwodecimalFixed } from '@/utils/util';
import { pay as payFun } from '@/views/pay/pay';
export default {
    name: 'OrderListDetail',
    data() {
        return {
            orderDetail: {
                packageObj:{},
                groupVO: {}
            },
            statusList: [
                {value: 'STRIPE', label: this.$t('order.orderList.payMethod_stripe')},
            ],
            isBuyFlag: false,
        }
    },
    mounted() {
        this.getOrderDetail();
        this.checkCanBuyAgain();
    },
    filters:{
        filterTime(time) {
            if (!time) return "";
            let dateFormat = 'yyyy/MM/dd HH:mm'
            let langType = cookie.getCookie('langType')
            if(['es-ES','pt-PT','de-DE','fr-FR','it-IT','tr-TR'].includes(langType)){
                dateFormat = 'dd/MM/yyyy HH:mm'
            }
            return dateUtil.formatDateTime(new Date(time), dateFormat);
        },
    },
    methods: {
        e_goBack() {
            this.$router.go(-1);
            sessionStorage.setItem('orderType','order')
        },
        // 转化状态
        getLabel(value) {
            const obj = this.statusList.find(item => item.value === value);
            return obj ? obj.label : value;
        },
        // 判断是否使用了货币符号
        isCurrencySymbol(price='') {
            let typeList = [];
            if(this.$APP_CONFIG.currencyTypeMap) {
                typeList = Object.keys(this.$APP_CONFIG.currencyTypeMap);
            }
            return typeList.some(item => {
                return price?.toLowerCase()?.includes(item) && this.$APP_CONFIG.currencyTypeMap[item];
            })
        },
        // 查询订单详情
        getOrderDetail() {
            this.$http
            .post({
            url: "/bss/app/order/queryOrderListForApp",
            data: {
                perPageCount: 1000,
                orderStatusList: ['UNPAID', 'CANCEL', 'FINISHED', 'PENDING', 'CLOSE'],
                queryLimitFlag: true,
                custTerminalFlag: 1,
                filterTopupCode: 1,
                orderId: this.$route.query.orderId,
            }
            })
            .then(res => {
                if(res.data && res.data?.dataList?.length){
                    let list = res.data.dataList.filter(item => item.orderId === this.$route.query.orderId).map(item => {
                        this.doPriceStyle(item, item.amount, 'amountText');
                        this.doPriceStyle(item, item.originalAmount, 'originalAmountText');
                        this.doPriceStyle(item, item.discountAmount, 'discountAmountText');
                        this.doPriceStyle(item, item.offerList?.[0]?.goodsPrice || '', 'goodsPriceText');
                        let showFlow = this.doFlowByteText(item.offerList?.[0] || {}) + ' ' + this.genHighSeepText(item.offerList?.[0] || {});
                        let showPeriod = this.getValidityPeriod(item.offerList?.[0] || {});
                        let actName = item.orderMktList?.[0]?.actName || '';
                        return {
                            ...item,
                            packageObj: item.offerList?.[0] || {},
                            groupVO: item.groupVO || {},
                            showFlow,
                            showPeriod,
                            actName
                        }
                    });
                    this.orderDetail = list[0] || {};
                }
            })
            .catch(err => {
                this.$toast(err);
                console.log(err);
            });
        },
        //检查是否可再次购买
        checkCanBuyAgain() {
            if (!this.$route.query.orderId) return;
            this.$http
                .post({
                url: "/bss/app/orderRelation/checkOrderCanCancelOrReBuy",
                data: {
                    orderId: this.$route.query.orderId,
                    channel: "WEB"
                }
                })
                .then(da => {
                    this.isBuyFlag = da.data.isBuyFlag;
                });
        },
        // 取消订单
        gotoCancel() {
            this.$dialog.confirm({
                title:this.$t('flowDetail.tip'),
                message: this.$t('order.orderList.goto_cancel'),
                confirmButtonText:this.$t('registerlogin.confirm'),
                cancelButtonText:this.$t('registerlogin.cancel')
            }).then(() => {
                    this.$http
                        .post({
                            url: "/bss/app/order/cancelUnpaidOrder",
                            data: {
                                orderId: this.orderDetail.orderId,
                                orderSN: this.orderDetail.orderSN
                            }
                        })
                        .then(res => {
                            this.getOrderDetail();
                        })
                        .catch(err => {
                            this.$toast(err);
                            console.log(err);
                        });
                }).catch(() => {
                })
        },
        // 去支付
        gotoPay() {
            this.$http
                .post({
                    url: "/bss/app/order/checkOrderPayValidate",
                    data: {
                        orderId: this.orderDetail.orderId,
                        orderSN: this.orderDetail.orderSN,
                    }
                })
                .then(res => {
                    if(res.data?.orderSN && res.data?.amount){
                        // 去收银台支付
                        let payAgreeFlag = this.orderDetail.packageObj.payAgreeFlag == '1' && this.orderDetail.packageObj.categoryCode == 'LXCX';
                        //国家维度自定义收银台支付模板
                        let sessionStorage_UrlData = JSON.parse(sessionStorage.getItem('urlData') || '{}');
                        let countryCode = sessionStorage_UrlData.registerCountry|| 
                                            this.$projectConfig.registerCountry||
                                            sessionStorage_UrlData.placeCode||'';
                        payFun({
                            orderSn: res.data.orderSN,
                            totalAmount: res.data.amount,
                            currencyCode: res.data.currencyType,
                            orderDesc: res.data.orderDesc,
                            orderSubject: this.orderDetail.packageObj?.goodsName,
                            payFunction: payAgreeFlag&&'CYCLE'||'PAY',
                            countryCode:countryCode,
                        });
                    } else {
                        this.getOrderDetail();
                    }
                })
                .catch(err => {
                    this.getOrderDetail();
                    this.$toast(err);
                    console.log(err);
                });
        },
        // 点击购买
        goBuy() {
            this.$router.push(this.$setRouteQuery({
                name: 'PackageDetail',
                query: {
                    goodsCode: this.orderDetail.packageObj.goodsCode,
                    categoryCode: this.orderDetail.packageObj.categoryCode,
                    goodsType: this.orderDetail.packageObj.goodsType,
                    souce:'订单详情',
                }
            },this));
        },
        doPriceStyle(item, price, key) {
          item[key] = this.globalPriceFormat(item.currencyType, price);
        },
        //连续包月增加--20241205--start
        getValidityPeriod (a) {
            // 有效期
            let periodTxt = '';

            if (a.attrMap.expType && (a.attrMap.expType == 'CURRENT_MONTH' || a.attrMap.expType == 'CURRENT_DAY')) {
                periodTxt = this.getTypeOfFailures(a);      // 失效类型
            } else {
                if (a.period == null || a.period == '') {
                    periodTxt = '';
                } else {
                    let actionType = this.getEffectiveType (a);     // 生效类型
                    periodTxt = a.period +' '+ this.getUnitOfTime (a.periodUnit, a.period) + ' ' + actionType;
                }
            }
            return periodTxt;
        },
        getEffectiveType (a) {
            // 生效类型
            let actionType = '';

            if (a != null && a != '' && a.attrMap.effType) {
                if (a.attrMap.effType == 'IMMEDIATELY') {
                    a.period == null || a.period == '' ? actionType = this.$t('packages.immediate_valid') : actionType = '('+ this.$t('packages.immediate_valid') +')'

                } else if (a.attrMap.effType == 'MORROW') {
                    a.period == null || a.period == '' ? actionType = this.$t('packages.tomorrow_day_valid') : actionType = '('+ this.$t('packages.tomorrow_day_valid') +')';

                } else if (a.attrMap.effType == 'USER_DEFINED') {
                    actionType = '';

                } else if (a.attrMap.effType == 'NEXT_MONTH') {
                    a.period == null || a.period == '' ? actionType = this.$t('packages.tomorrow_month_valid') : actionType = '('+ this.$t('packages.tomorrow_month_valid') +')';

                } else {
                    actionType = '';
                }
            }
            return actionType;
        },
        getUnitOfTime (a, b) {
            let unit = a;

            if (unit == 'DAY' || unit == null || unit == '') {
                if (parseInt(b) < 2 || b == null || b =='') {
                    unit = this.$t('packages.periodUnit.day');
                } else {
                    unit = this.$t('packages.periodUnits.day');
                }
            } else if (unit == 'MONTH') {
                if (parseInt(b) < 2 || b == null || b =='') {
                    unit = this.$t('packages.periodUnit.month');
                } else {
                    unit = this.$t('packages.periodUnits.month');
                }
            }
            return unit;
        },
        getTypeOfFailures (a) {
            // 失效类型
            let actionType = '';

            if (a != null && a != '' && a.attrMap.expType) {
                if (a.attrMap.expType == 'CURRENT_MONTH') {
                    actionType = this.$t('packages.month_invalid');
                } else if (a.attrMap.expType == 'CURRENT_DAY') {
                    actionType = this.$t('packages.day_invalid');
                } else if (a.attrMap.expType == 'DEFAULT') {
                    actionType = '';
                } else {
                    actionType = '';
                }
            }
            return  actionType;
        },
        genHighSeepText(item) {
            if (item.goodsType == 'DISC') { // unlimited packages
                if (['BYTC', 'SWBY', 'BTTC', 'LXCX'].includes(item.categoryCode)) {
                    item.high_speed_text = this.$t('packages.high_speed_text');
                    // 0为按小时取，1为按天取，2为按月取，3为按年取，12为动态月也是按月取同2
                    // 有限期和限速规则一样，显示高速流量
                    let billInfo = item.billingInfos;
                    if(billInfo && billInfo.length > 0) {
                        if(billInfo[0].periodUnit === 0) {
                            if(item.period == billInfo[0].period && item.periodUnit == 'HOUR') {
                                item.high_speed_text = this.$t('packages.high_speed_text');
                            } else {
                                if(billInfo[0].period > 1) {
                                    item.high_speed_text = item.high_speed_text + '/' + billInfo[0].period + this.$t('packages.periodUnitsSimp.hour')
                                } else {
                                    item.high_speed_text = item.high_speed_text + '/' + this.$t('packages.periodUnitSimp.hour')
                                }
                            }
                        } else if(billInfo[0].periodUnit === 1) {
                            if(item.period == billInfo[0].period && item.periodUnit == 'DAY') {
                            item.high_speed_text = this.$t('packages.high_speed_text');
                            } else {
                                if(billInfo[0].period > 1) {
                                    item.high_speed_text = item.high_speed_text + '/' + billInfo[0].period + this.$t('packages.periodUnitsSimp.day')
                                } else {
                                    item.high_speed_text = item.high_speed_text + '/' + this.$t('packages.periodUnitSimp.day')
                                }
                            }

                        } else if(billInfo[0].periodUnit === 2 || billInfo[0].periodUnit === 12) {
                            if(item.period == billInfo[0].period && item.periodUnit == 'MONTH') {
                                item.high_speed_text = this.$t('packages.high_speed_text');
                            } else {
                                if(billInfo[0].period > 1) {
                                    item.high_speed_text = item.high_speed_text + '/' + billInfo[0].period + this.$t('packages.periodUnitsSimp.month')
                                } else {
                                    item.high_speed_text = item.high_speed_text + '/' + this.$t('packages.periodUnitSimp.month')
                                }
                            }
                        } else if(billInfo[0].periodUnit === 3) {
                            if(item.period == billInfo[0].period && item.periodUnit == 'YEAR') {
                                item.high_speed_text = this.$t('packages.high_speed_text');
                            } else {
                                if(billInfo[0].period > 1) {
                                    item.high_speed_text = item.high_speed_text + '/' + billInfo[0].period + this.$t('packages.periodUnitsSimp.year')
                                } else {
                                    item.high_speed_text = item.high_speed_text + '/' + this.$t('packages.periodUnitSimp.year')
                                }
                            }
                        }
                    }
                }
            }

            return item.high_speed_text ? item.high_speed_text : '';
        },
        doFlowByteText(item) {
            let flowText = '0MB',
                flowValue = item.billingInfos && item.billingInfos.length ? item.billingInfos[0].flow : (item.flowByte ? item.flowByte : 0);                    

            if(flowValue >= 1000) {
                let flow = flowValue/1024;
                // 判断是不是整数
                if(Math.floor(flow) === flow) {
                    flowText = `${flow}GB`;
                } else {
                    let langType = cookie.getCookie('langType')
                    // 部分欧洲国家小数点采取 ， 形式
                    let country = ['es-ES','pt-PT','de-DE','fr-FR']; 
                    let showFlow = keepTwodecimalFixed(flow)
                    if(country.includes(langType)){
                        showFlow = showFlow.replace('.',',')
                    }
                    flowText = `${showFlow}GB`;
                }
            } else {
                flowText = `${flowValue}MB`;
            }

            return flowText;        
        },
    }
}
</script>

<style lang="less" scoped>
@import "~@/assets/theme.less";
.ml10 {
    margin-left: 10px;
}
.mr10 {
    margin-right: 10px;
}
.mt16 {
    margin-top: 16px;
}
.flex2 {
    flex: 2;
}
.border-bottom {
    border-bottom: 1px solid #c8c9cc;
}
.order-detail {
    background-color: #f2f2f2;
    min-height: 100vh;
    min-height: 100dvh;
    padding-bottom: 50px;
    .header-box {
        background: linear-gradient(270deg, #aef377 0%, #69be3e 100%);
        min-height: 140px;
        .status-box {
            color: #fff;
            font-size: 14px;
            margin-top: 20px;
            margin-left: 14px;
        }
    }
    .header-pending {
        background: linear-gradient(270deg, #ffef98 0%, #e79b48 100%);
    }
    .package-detail {
        background-color: #fff;
        border-radius: 8px;
        margin-left: 14px;
        margin-right: 14px;
        transform: translateY(-20px);
        padding: 12px;
        .amont-title {
            margin-top: 8px;
            font-size: 11px;
        }
    }
    .order-amont {
        padding-bottom: 18px;
        .pay-amont {
            font-size: 18px;
            font-weight: 600;
            color: #F74E4E;
        }
    }
    .order-info {
        margin-top: 12px;
        padding-bottom: 12px;
    }
    .order-detail-footer {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        // background-color: #fff;
        border-top: 1px solid #d7d7d7;
        height: 50px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        ::v-deep {
            .van-button--block {
                width: auto;
            }
        }
        .btn {
            height: 36px;
            line-height: 36px;
            min-width: 100px;
            text-align: center;
            font-size: 14px;
            border-radius: 18px;
            border: none;
            margin-right: 10px;
        }
        .gobuy {
            color: #fff;
            background-color: @theme-color;
        }
        .delete {
            color: #000;
            background-color: #fff;
        }
    }
}
::v-deep {
    .van-cell {
        background-color: transparent;
        padding: 0;
    }
}
html[dir="rtl"] {
    .order-detail {
        .header-box {
            background: linear-gradient(135deg, #aef377 0%, #69be3e 100%);
            ::v-deep {
                .van-icon {
                    color: #fff;
                }
            }
            .status-box {
                margin-left: unset;
                margin-right: 14px;
            }
        }
        .header-pending {
            background: linear-gradient(135deg, #ffef98 0%, #e79b48 100%);
        }
        .package-detail {
            .amont-title {
                direction: ltr;
                text-align: right;
                .goodsPrice {
                    direction: rtl;
                    display: inline-block;
                }
            }
        }
    }
    .order-detail-footer {
        padding-left: 10px;
    }
    .van-cell__value {
        text-align: left;
    }
    .arValue {
        direction: ltr;
    }
}
</style>